import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '@wealthlane/api-services/wealthlane-customer-service';
import { DisbursementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetDisbursementStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const DisbursementStatus = useQuery(
    ['getDisbursementStatus'],
    async () => {
      return await handleRequest(
        DisbursementService.getApiAwardSettlementApiAppDisbursementDisbursementStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return DisbursementStatus;
};

export default useGetDisbursementStatus;
